import { asIdentifier } from "@safesphere/contracts";
const jurisdictionId = asIdentifier("fixture-jurisdiction");
const sourceId = asIdentifier("fixture-source");
const guidelineId = asIdentifier("fixture-guideline");
const topicId = asIdentifier("fixture-topic");
const authorId = asIdentifier("fixture-author");
const thaiReviewerId = asIdentifier("fixture-reviewer-th");
const englishReviewerId = asIdentifier("fixture-reviewer-en");
export const fictionalTopic = {
    id: topicId,
    kind: "PREPAREDNESS_CHECKLIST",
    slug: "fictional-empty-preparedness-topic",
    fictionalFixture: true,
    createdAt: "2026-09-01T00:00:00.000Z",
};
export const fictionalSource = {
    id: sourceId,
    title: "Fictional empty schema source",
    publisher: "Fictional Preparedness Laboratory",
    authorityType: "PROFESSIONAL_BODY",
    jurisdictionId,
    sourceLanguage: "en",
    sourceUrl: "https://example.invalid/safesphere/non-authoritative-fixture",
    publishedAt: "2026-08-01T00:00:00.000Z",
    retrievedAt: "2026-09-01T00:00:00.000Z",
    evidenceNotes: "Non-authoritative fixture used only to validate governance workflow.",
};
export const fictionalGuideline = {
    id: guidelineId,
    title: "Fictional empty document",
    publisher: "Fictional Preparedness Laboratory",
    jurisdictionId,
    sourceIds: [sourceId],
    documentIdentifier: "FIXTURE-DOC-001",
    publishedAt: "2026-08-01T00:00:00.000Z",
    retrievedAt: "2026-09-01T00:00:00.000Z",
};
export const fictionalReviewers = [
    {
        id: authorId,
        displayName: "Fictional Fixture Author",
        qualifications: ["TEST_FIXTURE_ONLY"],
        active: true,
    },
    {
        id: thaiReviewerId,
        displayName: "Fictional Thai Reviewer",
        qualifications: ["TEST_FIXTURE_ONLY", "THAI_REVIEW_FIXTURE"],
        active: true,
    },
    {
        id: englishReviewerId,
        displayName: "Fictional English Reviewer",
        qualifications: ["TEST_FIXTURE_ONLY", "ENGLISH_REVIEW_FIXTURE"],
        active: true,
    },
];
function createThaiFixture() {
    const revisionId = asIdentifier("fixture-revision-th-1");
    const reviewId = asIdentifier("fixture-review-th-1");
    const editorial = {
        id: asIdentifier("fixture-editorial-th-1"),
        revisionId,
        locale: "th",
        contentHash: "fixture-content-hash-th-1",
        state: "VERIFIED",
        authorId,
        reviewerId: thaiReviewerId,
        reviewDecisionId: reviewId,
        reviewedAt: "2026-09-15T00:00:00.000Z",
        updatedAt: "2026-09-15T00:00:00.000Z",
    };
    return {
        revision: {
            id: revisionId,
            topicId,
            locale: "th",
            revisionNumber: 1,
            contentHash: editorial.contentHash,
            payload: {
                fixtureNotice: "ข้อมูลสมมติสำหรับทดสอบโครงสร้างเท่านั้น ไม่มีคำแนะนำด้านความปลอดภัย",
                sections: [],
            },
            sourceIds: [sourceId],
            guidelineIds: [guidelineId],
            jurisdictionId,
            evidenceNotes: "Fictional empty Thai revision for deterministic tests.",
            evidenceClassification: "OFFICIAL_SECONDARY",
            confidence: "MODERATE",
            authorId,
            createdAt: "2026-09-10T00:00:00.000Z",
        },
        editorial,
        sources: [fictionalSource],
        guidelines: [fictionalGuideline],
        reviewers: fictionalReviewers,
        reviewDecisions: [
            {
                id: reviewId,
                revisionId,
                locale: "th",
                contentHash: editorial.contentHash,
                reviewerId: thaiReviewerId,
                decision: "APPROVE",
                decidedAt: editorial.reviewedAt ?? "",
                notes: "Approved fictional empty fixture; no safety claims present.",
            },
        ],
        dispositions: [],
    };
}
function createEnglishFixture() {
    const revisionId = asIdentifier("fixture-revision-en-1");
    const reviewId = asIdentifier("fixture-review-en-1");
    const editorial = {
        id: asIdentifier("fixture-editorial-en-1"),
        revisionId,
        locale: "en",
        contentHash: "fixture-content-hash-en-1",
        state: "VERIFIED",
        authorId,
        reviewerId: englishReviewerId,
        reviewDecisionId: reviewId,
        reviewedAt: "2026-09-16T00:00:00.000Z",
        updatedAt: "2026-09-16T00:00:00.000Z",
    };
    return {
        revision: {
            id: revisionId,
            topicId,
            locale: "en",
            revisionNumber: 1,
            contentHash: editorial.contentHash,
            payload: {
                fixtureNotice: "Fictional schema test only. Contains no safety guidance.",
                sections: [],
            },
            sourceIds: [sourceId],
            guidelineIds: [guidelineId],
            jurisdictionId,
            evidenceNotes: "Fictional empty English revision for deterministic tests.",
            evidenceClassification: "OFFICIAL_SECONDARY",
            confidence: "MODERATE",
            authorId,
            createdAt: "2026-09-11T00:00:00.000Z",
        },
        editorial,
        sources: [fictionalSource],
        guidelines: [fictionalGuideline],
        reviewers: fictionalReviewers,
        reviewDecisions: [
            {
                id: reviewId,
                revisionId,
                locale: "en",
                contentHash: editorial.contentHash,
                reviewerId: englishReviewerId,
                decision: "APPROVE",
                decidedAt: editorial.reviewedAt ?? "",
                notes: "Approved fictional empty fixture; no safety claims present.",
            },
        ],
        dispositions: [],
    };
}
export function createFictionalGovernanceFixtures() {
    return [createThaiFixture(), createEnglishFixture()];
}
